import styled from '@emotion/styled';
import * as Tabs from '@radix-ui/react-tabs';

export const TabsRoot = styled(Tabs.Root)`
  overflow: hidden;
`;

export const TabsList = styled(Tabs.List)`
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  gap: 8px;
`;

export const TabsIdContainer = styled.div`
  width: 100%;
`;

export const TabsTrigger = styled(Tabs.Trigger)`
  width: 100%;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.zinc_400};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: ${({ theme }) => theme.lineHeight.md};

  transition: all 0.15s ease-in-out;

  &[data-state='active'],
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.skyblue_300};
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.skyblue_300};
  }
`;

export const TabsContent = styled(Tabs.Content)<{ height?: string }>`
  height: ${({ height }) => height ?? 'auto'};
`;
